/**
 * Parses an array of input prop objects to be passed to an input element performing the following:
 *
 * - generates a label value to be used for the input if the `items` arg is array of strings
 * - generates a unique id based on the base `id` arg if no id already exists in the props object
 *
 * ```
 * const items = parseFieldItems(["Task 1", "Task 2"], "tasks")
 * // Output
 * [ { id: "tasks-0", label: "Task 1" }, { id: "tasks-1", label: "Task 2" }]
 * ```
 *
 * @param items – Array of input item props or string value to be used for a label
 * @param id – The base id which to auto-generate unique input IDs for each item
 */
const parseFieldItems = (items, id) => items.map(item => typeof item === "string" ? {
  label: item
} : item).map((item, idx) => ({
  id: `${id}-${idx}`,
  key: `${id}-${idx}`,
  ...item
}));

/**
 * Parses an array of prop objects to be passed to an element performing the following:
 *
 * - generates a label value to be used if the `items` arg is array of strings
 *
 * ```
 * const items = parseItems<(["Task 1", "Task 2"], "tasks")
 * // Output
 * [ { label: "Task 1" }, { label: "Task 2" }]
 * ```
 *
 * @param items – Array of input item props or string value to be used for a label
 */
const parseItems = items => items.map(item => typeof item === "string" ? {
  label: item
} : item);

export { parseFieldItems, parseItems };
